import { render, staticRenderFns } from "./ShopConfig.vue?vue&type=template&id=162f74d2&"
import script from "./ShopConfig.vue?vue&type=script&lang=js&"
export * from "./ShopConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports